import { render, staticRenderFns } from "./oneCardAndTwoBooksType.vue?vue&type=template&id=2e14467e&scoped=true&"
import script from "./oneCardAndTwoBooksType.vue?vue&type=script&lang=js&"
export * from "./oneCardAndTwoBooksType.vue?vue&type=script&lang=js&"
import style0 from "./oneCardAndTwoBooksType.vue?vue&type=style&index=0&id=2e14467e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e14467e",
  null
  
)

export default component.exports